import React from 'react';
import KeyboardPromotionDF from '../components/SimulatorsComponents/DefualtSimulators/KeyboardPromotionDF';

//= ========================================================================
const Sim_Y02_keyboardPromotion = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <KeyboardPromotionDF
    globJSON={globJSON}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_Y02_keyboardPromotion;
